module.exports = __webpack_public_path__ + "static/img/1.9bd0389.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/4/eng/1.png
// module id = GSXN
// module chunks = 0